import { render, staticRenderFns } from "./colegios.vue?vue&type=template&id=472dc76c&scoped=true"
import script from "./colegios.vue?vue&type=script&lang=js"
export * from "./colegios.vue?vue&type=script&lang=js"
import style0 from "./colegios.vue?vue&type=style&index=0&id=472dc76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472dc76c",
  null
  
)

export default component.exports